import React, { useMemo, memo } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../../components/DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const BaseSectors: React.FC<BaseSectors.Props> = ({
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();
	const lang = useTypedSelector((state) => state.session.language);
	const sectors = useTypedSelector(
		(state) => state.globalState.carSectors.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.sector`),
		[t],
	);

	const value = useMemo<PolygonList | undefined>(
		() =>
			taxiServiceId
				? sectors
						?.filter(
							(item) => item?.taxiServiceId === taxiServiceId,
						)
						.map((sector) => ({
							id: sector.id,
							name:
								`${text} ${sector.name?.[lang]}` ||
								Object.values(sector.name)?.[0],
							color: theme.colors.warning,
							vertices: sector.vertices.map((v) => [
								v.lat,
								v.lng,
							]),
							editable: false,
						}))
				: sectors?.map((sector) => ({
						id: sector.id,
						name:
							`${text} ${sector.name?.[lang]}` ||
							Object.values(sector.name)?.[0],
						color: theme.colors.warning,
						vertices: sector.vertices.map((v) => [v.lat, v.lng]),
						editable: false,
				  })),
		[lang, sectors, text, taxiServiceId],
	);

	return <Map.PolygonEditor value={value} editing={false} />;
};

declare namespace BaseSectors {
	interface Props {
		taxiServiceId?: number;
	}
}

export const Sectors = memo(BaseSectors);
export default BaseSectors;
